import { useState } from 'react';
import { Mail, CheckCircle } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { useToast } from '@/hooks/use-toast';

export function Newsletter() {
  const [email, setEmail] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const { toast } = useToast();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!email) {
      toast({
        title: 'Error',
        description: 'Por favor, introduce tu email',
        variant: 'destructive',
      });
      return;
    }

    // Simulate subscription
    setIsSubmitted(true);
    toast({
      title: '¡Suscripción exitosa!',
      description: 'Recibirás nuestras mejores guías y ofertas.',
    });
  };

  return (
    <section className="border-t border-border bg-secondary/30 py-16">
      <div className="container-wide">
        <div className="mx-auto max-w-2xl text-center">
          {/* Icon */}
          <div className="mb-6 inline-flex h-14 w-14 items-center justify-center rounded-full bg-primary/10">
            <Mail className="h-7 w-7 text-primary" />
          </div>

          {/* Title */}
          <h2 className="mb-4 font-display text-2xl font-bold md:text-3xl">
            No te pierdas las mejores ofertas
          </h2>
          <p className="mb-8 text-muted-foreground">
            Suscríbete y recibe análisis exclusivos, comparativas y descuentos 
            en las mejores sillas de escritorio.
          </p>

          {/* Form */}
          {isSubmitted ? (
            <div className="flex items-center justify-center gap-3 rounded-lg bg-primary/10 p-4">
              <CheckCircle className="h-5 w-5 text-primary" />
              <span className="font-medium text-primary">
                ¡Gracias! Te has suscrito correctamente.
              </span>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="flex gap-2">
              <Input
                type="email"
                placeholder="tu@email.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="h-12 flex-1"
              />
              <Button type="submit" size="lg" className="h-12 px-8">
                Suscribirme
              </Button>
            </form>
          )}

          {/* Privacy Note */}
          <p className="mt-4 text-xs text-muted-foreground">
            Respetamos tu privacidad. Puedes darte de baja en cualquier momento.
          </p>
        </div>
      </div>
    </section>
  );
}